var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery } from 'react-query';
import GLOBAL_CONFIG from '../global-variables';
import { AuthContext } from '@michelin/central-provider';
import { useCallback, useContext } from 'react';
import { buildQueryParams as DEFAULT_BUILD_QUERY_PARAMS, createQueryParams } from '../utilities';
import { getDataSourceFactory } from '../utilities/getDataSource';
export const API_BASE_URL = GLOBAL_CONFIG.restAPIUrl;
export const IS_TEST = GLOBAL_CONFIG.test;
export var MethodType;
(function (MethodType) {
    MethodType["GET"] = "GET";
})(MethodType || (MethodType = {}));
function getLastModified(api, app, entity, authResultToken, identifier, filters) {
    return __awaiter(this, void 0, void 0, function* () {
        const headers = {
            'Authorization': `Bearer ${authResultToken}`
        };
        const method = MethodType.GET;
        const params = createQueryParams(Object.assign({}, Object.assign(Object.assign({ application: app, entity, identifier }, (filters || {})), { $limit: 1 })));
        const responseData = yield fetch(`${api}?${params}`, {
            cache: 'no-cache',
            headers,
            method,
        });
        let result = (yield responseData.json()) || [];
        result = result && result.data && result.data.length ? result.data[0].datetime : null;
        return result;
    });
}
function useGetAuthTokenResult() {
    const { authResult } = useContext(AuthContext);
    return authResult ? authResult.accessToken : null;
}
export function useChangeLog(params) {
    const { api, app, entity, identifier, except, filters, ignore, buildQueryParams = DEFAULT_BUILD_QUERY_PARAMS, } = params;
    const authResultToken = useGetAuthTokenResult();
    const getDataSource = useCallback(getDataSourceFactory({
        buildQueryParams,
    }), [buildQueryParams]);
    return getDataSource({
        api,
        app,
        authResultToken,
        entity,
        identifier,
        except,
        filters,
        ignore
    });
}
export function useLastModified(api, app, entity, shouldRefresh, identifier, filters) {
    const authResultToken = useGetAuthTokenResult();
    return useQuery(['ui-change-log', app, entity], () => getLastModified(api, app, entity, authResultToken, identifier, filters));
}
//# sourceMappingURL=useChangelog.js.map